import * as React from "react";

const Status = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.78008 2.00002C3.78008 1.66865 3.51145 1.40002 3.18008 1.40002C2.84871 1.40002 2.58008 1.66865 2.58008 2.00002V2.40002V3.00002V10V10.6V14C2.58008 14.3314 2.84871 14.6 3.18008 14.6C3.51145 14.6 3.78008 14.3314 3.78008 14V10.6H12.3185C13.1631 10.6 13.6926 9.68759 13.2736 8.95427L11.8711 6.50002L13.2736 4.04578C13.6926 3.31246 13.1631 2.40002 12.3185 2.40002H3.78008V2.00002ZM3.78008 3.60002V9.40002H12.1462L10.8009 7.04578C10.6076 6.7076 10.6076 6.29245 10.8009 5.95427L12.1462 3.60002H3.78008Z"
    />
);

export const Flag = {
    Status,
};
